document.addEventListener('DOMContentLoaded', () => {

  const hero = document.querySelector('.hero');
  const line = document.querySelector('.hero__line');
  const main = document.querySelector('.hero__main');
  const image = document.querySelector('.hero__image-box');

  if (hero && line && main && image) {

    var rangeTop = image.offsetTop;
    var rangeBottom = rangeTop + 100;
    var range = rangeBottom - rangeTop;
    var p = 0;
    var h = 0;
    var y = rangeTop;

    function setRange(p) {
      h = range / 100 * (100 - p);
      y = rangeTop + h;
    }

    function positionElements() {

      const mainOffsetY = main.querySelector('.hero__icon').getBoundingClientRect().height;

      line.style.top = y + 'px';
      main.style.top = (y - mainOffsetY) + 'px';
      image.style.clipPath = 'inset(' + h + 'px 0 0 0)';

    }

    function changeY(p) {

      const scrollY = window.scrollY;
      const heroY = hero.offsetTop;
      const heroHeight = hero.getBoundingClientRect().height;

      if (typeof p == 'undefined') {
        p = Math.floor((scrollY - heroY) / (heroHeight - 30) * 100);
        if (p > 100) p = 100;
      }

      if (!window.matchMedia("(min-width: 1200px)").matches) {
        p = 100;
      }

      setRange(p);
      positionElements();

    }

    changeY(100);

    setTimeout(() => {
      hero.classList.remove('hero--init');
      changeY();
    }, 100);

    document.addEventListener('scroll', function(e) {
      changeY();
    });

    window.addEventListener('resize', function(e) {
      rangeTop = image.offsetTop;
      changeY();
    });

  }

});
